import _ from "lodash";
// import draftToHtml from "draftjs-to-html";
import { fetchApi } from "../../utils";

const mapField = data => {
  return {
    ...data,
  };
};

const fetchPostCategoriesApi = () => {
  return fetchApi("post_categories")
    .then(res => _.get(res, "data"))
    .then(mapField);
};

export { fetchPostCategoriesApi };



// WEBPACK FOOTER //
// ./src/services/page/postcategories.js